export default __webpack_public_path__ + "static/media/ic_choose_location.dc2bcdb5.svg";